const schema = {
    "definitions": {},
    "$schema": "http://json-schema.org/draft-07/schema#",
    "type": "object",
    "title": "The Root Schema",
    "required": [
      "modules",
      "courses",
      "topics",
      "languages"
    ],
    "properties": {
      "modules": {
        "$id": "#/properties/modules",
        "type": "array",
        "title": "The Modules Schema"
      },
      "courses": {
        "$id": "#/properties/courses",
        "type": "array",
        "title": "The Courses Schema"
      },
      "topics": {
        "$id": "#/properties/topics",
        "type": "array",
        "title": "The Topics Schema"
      },
      "languages": {
        "$id": "#/properties/languages",
        "type": "array",
        "title": "The Languages Schema"
      }
    }
  }

  export default schema; 